"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgQuestionMarkFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M12 2c5.523 0 10 4.478 10 10s-4.477 10-10 10S2 17.522 2 12 6.477 2 12 2zM9.121 7.51c-.205.295-.365 1.052.376 1.442.74.39 1.098-.05 1.26-.29A1.5 1.5 0 0113.5 9.5c0 .44-.33 1.063-1.213 1.633-.225.146-1.294.779-1.258 1.867.006.198.145.987.93 1 1.034.017.882-.934 1.453-1.364.712-.537 2.088-1.559 2.088-3.136a3.5 3.5 0 00-6.379-1.99zM12 15.5a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z' }))); };
exports.default = SvgQuestionMarkFilled;
//# sourceMappingURL=QuestionMarkFilled.js.map